module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-helper', [_c('div', {
    attrs: {
      "slot": "form-header"
    },
    slot: "form-header"
  }, [_c('h2', [_vm._v("Warengruppen")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-fields"
    },
    slot: "form-fields"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-3 pa-2"
  }, [_c('v-card-title', [_c('h4', {
    staticClass: "grey--text"
  }, [_vm._v(" File Upload ")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey--text"
  }, [_vm._v("\n                        " + _vm._s(_vm.fileSrc.name) + "\n                    ")]), _vm._v(" "), _c('v-card-actions', [_c('v-flex', {
    attrs: {
      "xs-2": "",
      "offset-xs5": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey darken-3 file-btn",
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', {
    staticClass: "grey--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("backup")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|ext:csv'),
      expression: "'required|ext:csv'"
    }],
    attrs: {
      "name": "import_file",
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('import_file')),
      expression: "errors.has('import_file')"
    }],
    staticClass: "small red--text"
  }, [_vm._v(_vm._s(_vm.errors.first('import_file')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-xs": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text')], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-commands"
    },
    slot: "form-commands"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.submitted
    }
  }, [_c('v-icon', {
    staticClass: "green--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("done")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/dashboard",
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("close")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34f706fc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/import/importWarengruppen.vue
// module id = 320
// module chunks = 0